var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"brand",attrs:{"role":"img","aria-label":"SIMA"}},[_c('span',{staticClass:"brand__star",style:(_vm.starStyle)}),(_vm.wordmark)?_c('span',{staticClass:"brand__word"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }